
export const BASE_WINDOW_WIDTH = 1280;
export const BASE_WINDOW_HEIGHT = 720;

export const CONTAINER_PADDING = 32;
export const CONTAINER_TABLET_PADDING_TB = 32;
export const CONTAINER_TABLET_PADDING_LR = 32;

export const EM_DEFAULT_FONTSIZE = 10;

export const ResponsiveW = (pixel: number) => `${(pixel / BASE_WINDOW_WIDTH) * 100}vw`;
export const ResponsiveH = (pixel: number) => `${(pixel / BASE_WINDOW_HEIGHT) * 100}vh`;


export const ResponsiveEM = (pixel: number) => `${pixel / EM_DEFAULT_FONTSIZE}em`;